<template>
  <div class="shopbuy" v-show="page_finish">
    <v-app-bar
      app
    >
      <v-btn
        icon
        color="blue-grey darken-4"
        onclick="window.history.go(-1)"
      >
        <v-icon>mdi-less-than</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <div class="d-flex align-center mr-7">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://shop.cheerlife.io/img/logo_a.png"
          transition="scale-transition"
          width="22"
        />
        <v-toolbar-title>{{$t('shopbuy_title1')}}</v-toolbar-title>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-card class="mx-auto">
      <v-card-text>{{$t('shopbuy_title2')}}<font color="error">{{ shippingtype }}</font></v-card-text>
    </v-card>
    <br />
    <addressInput
      :getuserinfodata="userinfo_field"
      :onlyoneaddress="onlyone_address"
      :getisvendingmachine="is_vending_machine"
      v-if="userinfo_field.length"
    />
    <recriptTypenoe
      :getreceiptinfodata="userinfo_field"
      :getisvendingmachine="is_vending_machine"
      v-if="userinfo_field.length" />
    <!-- <recriptType
      :getreceiptinfodata="userinfo_field"
      v-if="userinfo_field.length"
    /> -->
    <payType />
    <couponInput v-show="!is_vending_machine" />
    <productInfo />
    <priceInfo />
    <sendOrderData />
    <CheerLifeFooter />
  </div>
</template>

<script>
// @ is an alias to /src
import CheerLifeFooter from '@/components/CheerLifeFooter.vue';
import addressInput from '../components/ShopBuy_Page/addressInput.vue';
import recriptTypenoe from '../components/ShopBuy_Page/recriptTypenoe.vue';
// import recriptType from '../components/ShopBuy_Page/recriptType.vue';
import payType from '../components/ShopBuy_Page/payType.vue';
import couponInput from '../components/ShopBuy_Page/couponInput.vue';
import productInfo from '../components/ShopBuy_Page/productInfo.vue';
import priceInfo from '../components/ShopBuy_Page/priceInfo.vue';
import sendOrderData from '../components/ShopBuy_Page/sendOrderData';

export default {
  name: 'shopbuy',
  components: {
    CheerLifeFooter,
    addressInput,
    recriptTypenoe,
    // recriptType,
    payType,
    couponInput,
    productInfo,
    priceInfo,
    sendOrderData,
  },
  computed: {

  },
  data: () => ({
    page_finish: false,
    access_key: 'rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c',
    user_line_id: '',
    userinfo_field: [],
    onlyone_address: [{
      order: false,
      rec: false,
    }],
    // 智販機
    is_vending_machine: true,
    shippingtype: '',
  }),
  methods: {
    async GetUserID() {
      // alert(window.location.href);
      if (
        sessionStorage.getItem('accessToken') !== '' &&
        sessionStorage.getItem('accessToken') !== null &&
        sessionStorage.getItem('user_uuid') !== '' &&
        sessionStorage.getItem('user_uuid') !== null
      ) {
        await this.checkUser();
      } else {
        return false;
      }
    },
    checkUser() {
      this.axios({
        method: 'post',
        url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/user-info`,
        headers: { 
          Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`
        },
        data: {
          user_uuid: sessionStorage.getItem('user_uuid'),
        },
      })
        .then((response) => {
          // console.log(response);
          if (response.status === 200) {
            let userinfo_data = [];
            userinfo_data.push(response.data);
            // store vuex
            this.$store.commit({
              type: 'setUserinfoData',
              userinfoData: userinfo_data,
            });
            // console.log(this.$store.state.userinfo.userinfoData);
            if (response.data.address_type === 0) {
              response.data.address_type = 1;
              response.data.address_type = String(response.data.address_type);
              this.onlyone_address[0].order = true;
            } else {
              response.data.address_type = String(response.data.address_type);
              this.onlyone_address[0].order = false;
            }
            if (response.data.rec_address_type === 0) {
              response.data.rec_address_type = 1;
              response.data.rec_address_type = String(response.data.rec_address_type);
              this.onlyone_address[0].rec = true;
            } else {
              response.data.rec_address_type = String(response.data.rec_address_type);
              this.onlyone_address[0].rec = false;
            }
            // 發票是否捐贈
            if (response.data.donate_invoice === true) {
              response.data.donate_invoice = 0;
            } else if (response.data.carrier_type !== '') {
              response.data.donate_invoice = 1;
            } else {
              response.data.donate_invoice = 2;
            }
            this.userinfo_field.push(response.data);
            // console.log(this.userinfo_field);
            // check product
            this.is_vending_machine = this.$store.state.productinfo.productinfoData[0].vending_machine;
            if (this.is_vending_machine === true) {
              this.shippingtype = '新竹智邦1樓智販機取貨';
            } else {
              this.shippingtype = '宅配到府';
            }
            this.$store.state.starpoint.starpointData.user_star_point = response.data.cheer_point;
          } else {
            alert(response.data.message);
          }
          this.page_finish = true;
        })
        .catch((error) => {
          this.page_finish = false;
          alert(`status code: ${ error.response.status }`);
          alert(error.response.data.message);
          if (error.response.data.message === 'token過期') {
            sessionStorage.setItem('accessToken', '');
            sessionStorage.setItem('user_uuid', '');
            document.cookie = 'accessToken' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'user_uuid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            window.history.go(-1);
          }
        });
    },
  },
  mounted() {
    this.GetUserID();
  },
  watch: {
  },
};
</script>
<style scoped lang="sass">
</style>>
